import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { NavigationCancel, NavigationCancellationCode, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PlatformLoadingState } from './shared/platform-loading-state';

import { PlatformAdminInactivityTimeoutService } from './core/services/platform-admin-inactivity-timeout.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PlatformLoadingState],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  private readonly inactivityTimeout = inject(PlatformAdminInactivityTimeoutService);
  protected readonly starting = signal(true);
  protected readonly startupError = signal(false);

  constructor() {
    inject(Router).events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.starting.set(false);
        this.startupError.set(false);
      } else if (event instanceof NavigationError || (event instanceof NavigationCancel
        && event.code !== NavigationCancellationCode.Redirect
        && event.code !== NavigationCancellationCode.SupersededByNewNavigation)) {
        this.startupError.set(true);
      }
    });
  }

  protected reload(): void {
    window.location.reload();
  }

  ngOnInit(): void {
    this.inactivityTimeout.start();
  }

  ngOnDestroy(): void {
    this.inactivityTimeout.stop();
  }
}
